export default "__VITE_ASSET__BKJ1k_41__"